module.exports = __webpack_public_path__ + "static/media/tenders.b92b1f00.jpg";